export const UPDATE_PHOTOBOOK_DATA = 'update_photobook_data';
export const UPDATE_PHOTOBOOK_NAME = 'update_photobook_name';
export const LIVE_MODE_MAX_PHOTOS = 200;
export const PRINT_SELECTION_MIN_PHOTOS = 20;
export const PRINT_SELECTION_MAX_PHOTOS = 150;
